<template>
  <FullPageLayout class="bg-[#f7f8fb]">
    <template v-if="fetchState.pending">
      <div class="flex justify-center my-5">
        <OLoading />
      </div>
    </template>
    <template v-else-if="fetchState.error">
      <ErrorPageLayout :error="fetchState.error" />
    </template>
    <template v-else>
      <VitrinHeader class="w-auto" :categories="allCategories" />
      <div class="max-w-[1100px] w-full mx-auto px-4 sm:px-0">
        <OBreadcrumb class="capitalize mt-7 mb-4 ml-1 sm:my-6 sm:ml-5" :items="breadcrumbRoutes" />
        <ArticleSlider
          v-if="allHeadlines.articles.length"
          :articles="allHeadlines.articles"
          arrow-color="#ff7352"
          :data-layer="{ name: `Vitrin - Slider` }"
          class="mb-4 sm:mb-6"
        >
          <SwiperSlide v-for="(article, index) in allHeadlines.articles" :key="article._id">
            <VitrinCarouselArticle :item="article" :lazy="index !== 0" />
          </SwiperSlide>
        </ArticleSlider>

        <VitrinIndexCategoryLayout :feed="allFeed" />

        <VitrinIndexCategoryLayout v-for="(item, index) in vitrinCategories" :key="index" :category="item.category" :feed="item.feed" />
      </div>
      <AdController unit="VitrinProject" />
    </template>
  </FullPageLayout>
</template>
<script>
import { defineComponent, useFetch, useContext, ref, useRoute, useMeta } from '@nuxtjs/composition-api';
import FullPageLayout from '@/modules/common/components/layout/FullPageLayout';
import ErrorPageLayout from '@/modules/common/components/layout/ErrorPageLayout.vue';
import { OLoading, OBreadcrumb } from '@/modules/common/components/ui';
import { initializeAdLoaders } from '@/modules/ads/adUtils';
import AdController from '@/modules/ads/components/AdController';
import SwiperSlide from '@/modules/sliders/core/SwiperSlide';
import VitrinHeader from '~/modules/vitrin/components/VitrinHeader';
import { mergeHeadItems } from '~/modules/common/utils/helpers';
import { useDevice } from '~/composables/useDevice';
import VitrinCarouselArticle from '~/modules/vitrin/components/VitrinCarouselArticle';
import VitrinIndexCategoryLayout from '~/modules/vitrin/components/VitrinIndexCategoryLayout';
import ArticleSlider from '~/modules/sliders/components/common/ArticleSlider';
import { useVitrinMeta } from '~/modules/vitrin/utils/vitrinMeta';
import { IS_ONEDIO } from '~/constants/config';

export default defineComponent({
  components: {
    FullPageLayout,
    ErrorPageLayout,
    OLoading,
    VitrinHeader,
    VitrinCarouselArticle,
    VitrinIndexCategoryLayout,
    OBreadcrumb,
    AdController,
    ArticleSlider,
    SwiperSlide,
  },
  setup() {
    const { generateAdConfig } = initializeAdLoaders();
    const route = useRoute();
    const { isMobile } = useDevice();
    const { $error, $service, $cache } = useContext();

    useMeta(() => {
      const { title, meta, link } = useVitrinMeta('vitrin', route.value.fullPath);
      return mergeHeadItems({ title }, { meta }, { link });
    });

    $cache('public, max-age=30');
    const breadcrumbRoutes = [{ href: route.value.fullPath, name: route.value.name.split('___')[0] }];
    const allCategories = ref([]);
    const allHeadlines = ref({});
    const allFeed = ref({});
    const vitrinCategories = ref([]);

    const serversideAdConfig = generateAdConfig('onlyGPT');
    const { fetch, fetchState } = useFetch(async () => {
      try {
        if (!IS_ONEDIO) {
          $error('Page not found', 404, false);
        }
        const { data } = await $service.vitrin.getVitrinFeed();
        const { categories, headlines, feed } = data;
        allCategories.value = categories;
        allHeadlines.value = headlines;
        allFeed.value = feed;
        vitrinCategories.value = await Promise.all(
          allCategories.value.map(async (item) => {
            const { data } = await $service.vitrin.getVitrinFeed(item.id);
            return data;
          })
        );
        serversideAdConfig(
          ref({
            type: 'Vitrin',
            targetingKey: 'Tümü',
          })
        );
      } catch (error) {
        $error(error);
      }
    });
    return { fetch, fetchState, allCategories, allHeadlines, allFeed, isMobile, vitrinCategories, breadcrumbRoutes };
  },
  head: {},
});
</script>
